import apicaller from "@/utils/apicaller";
import api from "../../main.api";
import { cddRejectOnError } from "./cddResponse";

export default {
  getDashboardStats() {
    return apicaller.get(api.CDD.dashboardStats);
  },
  getStatusSummary(params) {
    return apicaller.get(api.CDD.statusSummary, { params });
  },
  getAll(params) {
    return apicaller.get(api.CDD.runs, { params });
  },
  getById(id) {
    return apicaller.get(`${api.CDD.run}/get/${id}`);
  },
  getProgress(id) {
    return apicaller.get(`${api.CDD.run}/progress/${id}`);
  },
  getResults(id, params) {
    return apicaller.get(`${api.CDD.run}/results/${id}`, { params });
  },
  exportResultsCsv(id, params, cancelToken) {
    return apicaller.get(`${api.CDD.run}/results/${id}/csv`, {
      params,
      responseType: "blob",
      cancelToken,
    });
  },
  cancel(id) {
    return apicaller
      .post(`${api.CDD.run}/cancel/${id}`, {})
      .then(cddRejectOnError);
  },
  retry(id) {
    return apicaller
      .post(`${api.CDD.run}/retry/${id}`, {})
      .then(cddRejectOnError);
  },
  getResultDetail(runId, resultId) {
    return apicaller.get(`${api.CDD.run}/results/${runId}/detail/${resultId}`);
  }
};
